// Genera y descarga un CSV a partir de una lista de objetos (las llaves del primero son los encabezados).
// Incluye BOM para que Excel respete tildes y escapa las comillas de los valores.
export const downloadCsv = (filename: string, rows: Record<string, any>[]) => {
    if (!rows || rows.length === 0) return;

    const headers = Object.keys(rows[0]);
    const escape = (value: any) => `"${String(value ?? '').replace(/"/g, '""')}"`;

    const csvContent = [
        headers.map(escape).join(','),
        ...rows.map(row => headers.map(field => escape(row[field])).join(',')),
    ].join('\n');

    const blob = new Blob(['﻿' + csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

// Descarga un CSV ya armado (por ejemplo, el que genera el API). Incluye BOM para Excel.
export const downloadCsvText = (filename: string, csv: string) => {
    const blob = new Blob(['﻿' + csv.replace(/^﻿/, '')], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
};
